import { ErrorLogComponent } from '@cian/error-log-component';
import { ILogger } from '@cian/logger/shared';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { Gallery } from 'shared/components/NewbuildingGallery';
import { GallerySidebarContainer } from 'shared/containers/GallerySidebar';
import { useNewbuildingMedia } from 'shared/containers/NewbuildingGalleryContainer/utils/useNewbuildingMedia';
import { showFullScreen } from 'shared/store/gallery';

import { trackFullscreenOpen } from './tracking';
import { NewbuildingBookedOverlayContainer } from '../NewbuildingBookedOverlayContainer';

interface IGalleryContainerProps {
  reactErrorLogger: ILogger;
  phoneButton?: boolean;
  favoritesButton?: boolean;
}

export const GalleryContainer: React.FC<IGalleryContainerProps> = ({
  phoneButton = true,
  favoritesButton = true,
  reactErrorLogger,
}) => {
  const dispatch = useDispatch();
  const media = useNewbuildingMedia();

  const onFullscreenOpen = React.useCallback(() => {
    trackFullscreenOpen();
    dispatch(showFullScreen(0));
  }, [dispatch, trackFullscreenOpen, showFullScreen]);

  return (
    <div data-testid="OfferGallery" data-name="OfferGallery" id="photos">
      <ErrorLogComponent logger={reactErrorLogger}>
        <Gallery
          slotScrollerAfter={<NewbuildingBookedOverlayContainer />}
          slotFullscreenSidebar={<GallerySidebarContainer />}
          media={media}
          onFullscreenOpen={onFullscreenOpen}
        />
      </ErrorLogComponent>
    </div>
  );
};
